// Supabase CRUD for job openings (table: "jobs").
import { supabase } from "../supabase/client";

// Only these app fields differ from their DB column names.
const APP_TO_DB = { applyEmail: "apply_email" };

// DB (snake_case) → app (camelCase)
const fromRow = (r) => ({
  id: r.id,
  title: r.title,
  department: r.department,
  location: r.location,
  type: r.type,
  description: r.description,
  applyEmail: r.apply_email,
  active: r.active,
});

// app → DB, mapping only the keys that were actually provided (supports
// partial updates like the hide/show toggle without nulling other columns).
const toRow = (d) => {
  const out = {};
  for (const [k, v] of Object.entries(d)) out[APP_TO_DB[k] || k] = v;
  return out;
};

export async function getJobs() {
  const { data, error } = await supabase
    .from("jobs")
    .select("*")
    .order("created_at", { ascending: false });
  if (error) throw error;
  return data.map(fromRow);
}

export async function getJobById(id) {
  const { data, error } = await supabase
    .from("jobs")
    .select("*")
    .eq("id", id)
    .maybeSingle();
  if (error) throw error;
  return data ? fromRow(data) : null;
}

export async function addJob(data) {
  const { error } = await supabase.from("jobs").insert(toRow(data));
  if (error) throw error;
}

export async function updateJob(id, data) {
  const { error } = await supabase.from("jobs").update(toRow(data)).eq("id", id);
  if (error) throw error;
}

export async function deleteJob(id) {
  const { error } = await supabase.from("jobs").delete().eq("id", id);
  if (error) throw error;
}
